<template>
  <v-app>
    <v-tabs v-model="active" color="primary" dark slider-color="yellow">
      <v-tab-item>
        <v-container fluid>
          <v-layout align-start justify-space-around fill-height gap>
            <v-flex xs6 grow pr-4>
              <v-layout align-start justify-start column xs>
                <v-flex xs12>
                  <h1 class="headline">{{ $t("settings.createPriceRules.createNewPriceRule") }}</h1>
                </v-flex>
                <v-flex xs12 mt-3 grow class="full-width">
                  <v-form ref="form" v-model="form" class="xs12 full-width">
                    <v-flex xs12>
                      <v-autocomplete
                        :label="$t('settings.createPriceRules.chooseCluster')"
                        :items="items"
                        v-model="model.cluster_id"
                        :rules="[rules.required]"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        
                        v-model="model.min_price"
                        :rules="[rules.required]"
                        :label="$t('settings.createPriceRules.minimumPrice')"
                        type="text"
                        grow
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        
                        v-model="model.max_price"
                        :rules="[rules.required]"
                        :label="$t('settings.createPriceRules.maximumPrice')"
                        type="text"
                        grow
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        
                        v-model="model.event_min_price"
                        :label="$t('settings.createPriceRules.eventMinimumPrice')"
                        type="text"
                        grow
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        
                        v-model="model.event_max_price"
                        :label="$t('settings.createPriceRules.eventMaximumPrice')"
                        type="text"
                        grow
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        
                        v-model="model.min_time"
                        :rules="[rules.required]"
                        :label="$t('settings.createPriceRules.minimumTime')"
                        type="text"
                        grow
                      ></v-text-field>
                    </v-flex>
                    <br />
                    <v-flex xs12 align-end>
                      <v-btn
                        @click="addPriceRule"
                        :loading="loading"
                        color="secondary"
                        >{{ $t("settings.createPriceRules.createPriceRule") }}</v-btn
                      >
                    </v-flex>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
    </v-tabs>
  </v-app>
</template>

<script>
import axios from "axios";
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  name: "addPriceRule",
  title() {
    return this.$t("settings.createPriceRules.title");
  },
  components: {
    VueTagsInput,
  },
  data: () => ({
    active: 0,
    loading: false,
    error: false,
    items: [],
    model: {
      cluster_id: 0,
      min_price: 0.0,
      max_price: 0.0,
      event_min_price:0.0,
      event_max_price:0.0,
      min_time: 0,
    },

    form: false,
  }),
  computed: {
    rules() {
      return {
        required: (v) => !!v || this.$t("common.required"),
      };
    },
  },
  created() {
    this.loading = false;
    this.axios
      .get("getAllClustersTitles")
      .then((data) => {
        this.items = data.data.data;
      })
      .catch((err) => {
        this.error = true;
        let response = err.response;
        if (response) {
          window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
        } else {
          window.getApp.$emit("SHOW_TOAST", this.$t("settings.createPriceRules.checkYourInfo"), "red");
        }
      })
      .then(() => (this.loading = false));
  },

  methods: {
    addPriceRule() {
      if (this.$refs.form.validate()) {
        const formData = new FormData();

        this.loading = true;
        formData.append("pull_down_location_cluster_id", this.model.cluster_id);
        formData.append("max_price", this.model.max_price);
        formData.append("min_price", this.model.min_price);
        formData.append("event_max_price", this.model.event_max_price);
        formData.append("event_min_price", this.model.event_min_price);
        formData.append("min_time", this.model.min_time);
        this.axios
          .post('priceRule', formData)
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("settings.createPriceRules.priceRuleAdded"), "green");
            this.$router.push(`/priceRules`);
          })
          .catch((err) => {
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
            } else {
              window.getApp.$emit("SHOW_TOAST", this.$t("settings.createPriceRules.checkYourInfo"), "red");
            }
          })
          .then(() => (this.loading = false));
      }
    },
  },
};
</script>
